import { API_URL } from "@/config/config";
import $http from "@/Utils/$http";

const invoicesLink = params =>
  `${API_URL}business/${params.businessId}/branches/${params.branchId}/invoices/`;

export const getInvoicesList = async params =>
  (await $http.get(invoicesLink(params), { params })).data;
export const getInvoicesFiltered = async params =>
  (await $http.get(invoicesLink(params) + "filter", { params })).data;
export const getInvoiceData = async params =>
  (await $http.get(invoicesLink(params) + params.id)).data;
export const createInvoice = async params =>
  (await $http.post(invoicesLink(params), params)).data;
export const updateInvoice = async params =>
  (await $http.post(invoicesLink(params) + params.id, params)).data;
export const deleteInvoice = async params =>
  (await $http.post(invoicesLink(params) + params.id + "/delete")).data;
